import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableSummaryReportList = Loadable({
  loader: function loader() {
    return import('../SummaryReportList.jsx');
  },
  loading: ComponentLoading
});
export default LoadableSummaryReportList;